import dashboardIcon from "../../assets/icon/Vector.svg";
import productIcon from "../../assets/icon/ix_product.svg";
import categoryIcon from "../../assets/icon/icon-park-solid_category-management.svg";
import subCatIcon from "../../assets/icon/SubCat.svg";
import projectIcon from "../../assets/icon/eos-icons_project.svg";
import homePageIcon from "../../assets/icon/home.svg";
import userManagementIcon from "../../assets/icon/lucide_user-cog.svg";
import customerIcon from "../../assets/common/user-svgrepo-com.svg";
import ep_document from "../../assets/icon/ep_document.svg";
import salesIcon from "../../assets/icon/mdi_user.svg";
import { canAccessPath } from "../../lib/roleAccess";

export interface MenuItem {
  title: string;
  icon: string;
  path: string;
}

export const menus: MenuItem[] = [
  { title: "Dashboard", icon: dashboardIcon, path: "/dashboard" },
  { title: "Product", icon: productIcon, path: "/product" },
  { title: "Category", icon: categoryIcon, path: "/category" },
  { title: "Sub Category", icon: subCatIcon, path: "/subcategory" },
  { title: "Recent Project", icon: projectIcon, path: "/project" },
  { title: "Home Page", icon: homePageIcon, path: "/home-page" },
  { title: "User Management", icon: userManagementIcon, path: "/User" },
  { title: "Customer", icon: customerIcon, path: "/Customer" },
  { title: "Data Sales", icon: salesIcon, path: "/Sales" },
  { title: "Quotation", icon: ep_document, path: "/quotation" },
  { title: "Delivery Order", icon: ep_document, path: "/delivery_order" },
  { title: "DOS", icon: ep_document, path: "/dos" },
  { title: "Invoice", icon: ep_document, path: "/invoice" },
];

// Filter menu lewat konfigurasi role di lib/roleAccess.ts (ROLE_MENU_PATHS).
export const getMenusForRole = (role?: string | null) =>
  menus.filter((item) => canAccessPath(role, item.path));
